import React, { FC, useContext } from 'react';
import { Chart, ChartData, ChartOptions, ChartType, Plugin, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ReactChartJs } from 'react-chartjs-2';
import { ZoomContext } from 'context/ZoomContext';

Chart.register(...registerables, ChartDataLabels);
// Hide data labels for all charts by default. If we need it we can enable it in the options for each chart
Chart.defaults.set('plugins.datalabels', {
  display: false,
});

interface LineBarChartProps {
  data: ChartData;
  options: ChartOptions;
  type?: ChartType;
  plugins?: Plugin[];
}

const LineBarChart: FC<LineBarChartProps> = ({ data, options, type = 'bar', plugins }) => {
  // The app shell zooms #root (ZoomProvider, default 0.8), and Chart.js
  // hit-testing breaks under CSS zoom: mouse coordinates and painted pixels
  // disagree, so hovers land beside the bars instead of on them. Hosting the
  // canvas in an inverse-zoomed box restores an effective zoom of 1 for the
  // chart — the same compensation ModelsCalendar and FirmBaseLayout use.
  // Optional context read: stories/tests render without a ZoomProvider.
  const zoomLevel = useContext(ZoomContext)?.zoomLevel ?? 1;

  return (
    <div style={{ height: '100%', width: '100%', zoom: 1 / zoomLevel }}>
      <ReactChartJs type={type} data={data} options={options} plugins={plugins} />
    </div>
  );
};

export default LineBarChart;
